// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__17lOG","label":"Completed_label__3TCi_"};